import avatarModule from '../avatarModule';

function onInputFinished($log) {
  'ngInject';

  return {
    scope: {
      fn: '&onInputFinished'
    },
    restrict: 'A',
    link(scope, elem) {
      // bug: this fires before your mouse is let go in IE on input[type=range]
      // bug: Edge doesn't fire 'change' event for input[type=range], only 'input' event

      const isEdge = /Edge/.test(navigator.userAgent);

      if (isEdge && elem.is('input[type=range]')) {
        $log.debug('Is Edge, using input event');
        elem.on('input', function() {
          $log.debug('onInputFinished input');
          scope.$apply(scope.fn());
        });
      } else {
        $log.debug('Is not Edge, using change event');
        elem.on('change', function() {
          $log.debug('onInputFinished change');
          scope.$apply(scope.fn());
        });
      }
    }
  };
}

avatarModule.directive('onInputFinished', onInputFinished);

export default onInputFinished;
